import {
  type MobileLoginChallengeMutationVariables,
  useMobileLoginChallengeMutation,
  useMobileLoginPollLazyQuery,
} from 'api/core/generated';
import { APP_POLLING_INTERVALS, AppApiVersions } from 'app-constants';

export const useLoginByMobileId = () => {
  const [mobileIdLoginRequest, { data, loading, error }] =
    useMobileLoginChallengeMutation({
      context: { apiVersion: AppApiVersions.core },
    });

  const [
    getMobileIdState,
    {
      data: pollData,
      loading: pollLoading,
      error: pollError,
      startPolling,
      stopPolling,
    },
  ] = useMobileLoginPollLazyQuery({
    context: { apiVersion: AppApiVersions.core },
    fetchPolicy: 'network-only',
    pollInterval: APP_POLLING_INTERVALS.default,
  });

  const loginByMobileId = (variables: MobileLoginChallengeMutationVariables) =>
    mobileIdLoginRequest({ variables });

  return {
    loginByMobileIdProcessing: loading,
    mobileIdChallengeData: data?.challenge,
    loginByMobileIdError: error,
    loginByMobileId,
    getMobileIdState,
    startMobileIdStatePolling: startPolling,
    stopMobileIdStatePolling: stopPolling,
    mobileIdPollData: pollData?.challenge ?? {},
    mobileIdPollLoading: pollLoading,
    mobileIdPollError: pollError,
    authorizedByMobileId: Boolean(pollData?.challenge?.is_authenticated),
  };
};
